<template>
	<div>
		<b-nav fill tabs>
				<b-nav-item
					v-for="(tab, i) in tabs"
					:key="i"
					:active="tab.active"
					:disabled="tab.disabled"
					@click="getCurrentComponent(i)"
				>{{ tab.label }}</b-nav-item>
		</b-nav>
		<component :is="currentTabComponent"></component>


		<div class="form-actions">
			<b-button
				variant="primary"
				@click="saveCommandResponse"
				class="respone-background-primary pull-right border-0"
			>
				<font-awesome-icon icon="save" />
				{{ $t('next') }}
			</b-button>
		</div>
	</div>
</template>

<script>
	// import axios from 'axios'
	// import Utilities from '@/directives/Autocomplete/Utilities'
	import StaticTextTemplate from './Templates/StaticText'
	import StaticCardsTemplate from './Templates/StaticCards'
	import MediaTemplate from './Templates/Media'
	import ReceiptTemplate from './Templates/Receipt'
	import MapTemplate from './Templates/Map'
	export default {
		data() {
			return {
				currentTabComponent: StaticTextTemplate,
				tabActivePos: 0,
				command_id: null,
				service_id: null,
				tabs: [
					{
						title: 'static_text',
						label: 'Static text',
						active: true
					},
					{
						title: 'static_cards',
						label: 'Static cards',
						active: false
					},
					{
						title: 'media',
						label: 'Media',
						active: false
					},
					{
						title: 'receipt',
						label: 'Receipt',
						active: false
					},
					{
						title: 'map',
						label: 'Map',
						active: false
					},
				]
			}
		},
		methods: {
			getCurrentComponent(index) {
				for (let i = 0; i < this.tabs.length; i++) {
					this.tabs[i].active = false;
				}

				// let data;
				// if (this.$store.state.responseData) {
				// 	data = this.$store.state.responseData;
				// 	data.resp_type = this.tabs[index].title;
				// } else {
				// 	data = this.buildCommandResult({
				// 		resp_type: this.tabs[index].title
				// 	});
				// }

				// this.$store.commit('setResponseData', data);

				this.tabs[index].active = true
				switch (this.tabs[index].title) {
					case 'static_text':
						this.currentTabComponent = StaticTextTemplate
						break
					case 'static_cards':
						this.currentTabComponent = StaticCardsTemplate
						break
					case 'media':
						this.currentTabComponent = MediaTemplate
						break
					case 'receipt':
						this.currentTabComponent = ReceiptTemplate
						break
					case 'map':
						this.currentTabComponent = MapTemplate
						break
				}
			},
			saveCommandResponse() {
				this.$router.push(`/services/${this.service_id}/commands/${this.command_id}/result/fallback`)
			},
		},
		created() {
			this.command_id = this.$route.params.command_id
			this.service_id = this.$route.params.service_id
		},
	}
</script>

<style lang="scss" scoped>
</style>
